export const valueExists = (v) => {
  if (v && typeof v === "object") return Object.keys(v).length > 0;
  if (Array.isArray(v)) return v.length > 0;
  return v !== null && v !== undefined && v !== "";
};
